import React, { useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import "./rentalprocess.css"
import { BiCategoryAlt } from "react-icons/bi";
import { IoSearchOutline } from "react-icons/io5";
import { MdOutlineAccountCircle } from "react-icons/md";
import { FaShoppingCart } from "react-icons/fa";
import { IoHome } from "react-icons/io5";
import { AiOutlineDoubleRight } from "react-icons/ai";
import { Link } from "react-router-dom";
const RentalProcess = () => {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        message: "",
    });

    const [errors, setErrors] = useState({});
    const [statusMessage, setStatusMessage] = useState(""); // For feedback message
    const [captchaValid, setCaptchaValid] = useState(false); // Store reCAPTCHA validity

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const validateForm = () => {
        const newErrors = {};
        if (!formData.name) {
            newErrors.name = "Name is required";
        } else if (formData.name.length < 2) {
            newErrors.name = "Name must be at least 2 characters long";
        }
        if (!formData.email) {
            newErrors.email = "Email is required";
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            newErrors.email = "Invalid email address";
        }
        if (!formData.message) {
            newErrors.message = "Message is required";
        } else if (formData.message.length < 10) {
            newErrors.message = "Message must be at least 10 characters long";
        }
        if (!formData.phone) {
            newErrors.phone = "Phone number is required";
        } else if (!/^\d{10}$/.test(formData.phone)) {
            newErrors.phone = "Invalid phone number";
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleCaptchaChange = (value) => {
        setCaptchaValid(!!value); // If the CAPTCHA is filled out, set to true
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Check if form is valid and CAPTCHA is solved
        if (validateForm() && captchaValid) {
            console.log("Form submitted successfully", formData);

            // Clear any previous status message
            setStatusMessage("");

            try {
                // Send form data to the server using fetch
                const response = await fetch('/send-email', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(formData), // Send the formData, including phone
                });

                // Log the entire response to understand the data
                console.log("Response Status:", response.status);
                console.log("Response Body:", await response.text());

                // Check if the response is OK (status code 2xx)
                if (!response.ok) {
                    throw new Error(`Server error: ${response.statusText}`);
                }

                setStatusMessage("Your message has been sent successfully. We'll get back to you soon!");

                // Clear the form after successful submission
                setFormData({
                    name: "",
                    email: "",
                    message: "",
                    phone: "", // Reset phone field too
                });

            } catch (error) {
                console.error("Error sending email:", error);
                // Show error message
                setStatusMessage("There was an error sending your message. Please try again.");
            }
        } else {
            setStatusMessage("Please complete the CAPTCHA.");
        }
    };
    return (
        <>
                <div class="tf-page-title">
                  
                    <div class="row">
                      <div class="col-12">
                      
                        <div class="heading text-center ">
                        <h4 className='breadcrumbtitle'>RentalProcess</h4>
                          <div className=' breadcrumb'>
                          <Link to="/" style={{color:"black"}} ><h6>Home</h6></Link><AiOutlineDoubleRight size={20} style={{marginTop:"0.5vh"}}/>
          
                          <h6>RentalProcess</h6></div>
                          
                        </div>
                      </div>
                    </div>
                
                </div>
            <div class="rentalcontainer">
                <div>
                    <img src="./images/rentalprocess.png" />
                </div> <br />
                <div className="tf-content-right">
                    <h5 className="mb_20" style={{ fontFamily: "Raleway,serif" }}>Let's Connect To Know More .....</h5>
                    <div>
                        <form className="form-contact" onSubmit={handleSubmit}>
                            <div className="gap-15 mb_15 formfield">
                                <fieldset className="w-100">
                                    <input
                                        type="text"
                                        name="name"
                                        id="name"
                                        value={formData.name}
                                        onChange={handleChange}
                                        placeholder="Name *"
                                    />
                                    {errors.name && <p className="error-text">{errors.name}</p>}
                                </fieldset>
                                <fieldset className="w-100">
                                    <input
                                        type="email"
                                        name="email"
                                        id="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        placeholder="Email *"
                                    />
                                    {errors.email && <p className="error-text">{errors.email}</p>}
                                </fieldset>
                                <fieldset className="w-100">
                                    <input
                                        type="number"
                                        name="phone"
                                        id="phone"
                                        value={formData.phone}
                                        onChange={handleChange}
                                        placeholder="Phone *"
                                        required
                                    />
                                    {errors.phone && <p className="error-text">{errors.phone}</p>}
                                </fieldset>
                            </div>
                            <div className="mb_15">
                                <textarea
                                    placeholder="Message"
                                    name="message"
                                    id="message"
                                    value={formData.message}
                                    onChange={handleChange}
                                    cols="30"
                                    rows="10"
                                ></textarea>
                                {errors.message && <p className="error-text">{errors.message}</p>}
                            </div>
                            <div className="mb_15">
                                {/* Google reCAPTCHA */}
                                <ReCAPTCHA style={{maxWidth:"80%"}}
                                    sitekey="6LeT2ZIqAAAAAE8px5Uy95G1C4gd26JuYvPXatP9"  // Replace with your reCAPTCHA site key
                                    onChange={handleCaptchaChange}
                                />
                            </div>
                            <div className="send-wrap">
                                <button
                                    type="submit"
                                    className="tf-btn w-30 radius-3 btn-fill animate-hover-btn justify-content-center"
                                >
                                    Send
                                </button>
                            </div>
                        </form>
                        {statusMessage && (
                            <div>
                                <p>{statusMessage}</p>
                            </div>
                        )}
                    </div>
                </div><br />
                <b >How To Rent A Dress From RoyalHood</b>
                <p style={{marginBottom:"10px"}}><span style={{ fontWeight: "400px" }}>At RoyalHood, it is quite simple to rent a dress. Below we have discussed a step-by-step process on how it works:</span></p>
                <ol>
                    <li style={{ fontWeight: "400px" }} className="ol">
                        <b>Select Dress For Rent:</b><b><br /></b>
                    </li>
                    <ul className="ol" style={{marginTop:"10px",marginBottom:"10px"}}>
                        <li className="ul" style={{ fontWeight: "400px" }}><span style={{ fontWeight: "400px" }}>Browse through the wide range of dresses available on RoyalHood.</span></li>
                        <li className="ul" style={{ fontWeight: "400px" }}><span style={{ fontWeight: "400px" }}>Use filters to narrow down your choices based on occasion, designer, color, size, and style.</span></li>
                        <li className="ul" style={{ fontWeight: "400px" }}><span style={{ fontWeight: "400px" }}>Read descriptions and reviews to ensure you select the perfect dress.</span></li>
                    </ul>
                </ol>
                <ol start={2}>
                    <li style={{ fontWeight: "400px" }} className="ol" ><b>Select Your Timeframe:</b></li>
                    <ul  style={{marginTop:"10px",marginBottom:"10px"}}>
                        <li className="ul" style={{ fontWeight: "400px" }}><span style={{ fontWeight: "400px" }}>Choose the rental period that suits your needs. Typically, options include 3-day, 5-day or 7-day rentals.</span></li>
                        <li className="ul" style={{ fontWeight: "400px" }}><span style={{ fontWeight: "400px" }}>Ensure the dress is available for your chosen dates using the website’s availability calendar.</span></li>
                    </ul>
                </ol>
                <ol start={3}>
                    <li style={{ fontWeight: "400px" }} className="ol"><b>Make Payment:</b></li>
                    <ul  style={{marginTop:"10px",marginBottom:"10px"}}>
                        <li className="ul" style={{ fontWeight: "400px" }}><span style={{ fontWeight: "400px" }}>Add your selected dress to the cart.</span></li>
                        <li className="ul" style={{ fontWeight: "400px" }}><span style={{ fontWeight: "400px" }}>Proceed to checkout, where you will provide your shipping and payment details.</span></li>
                        <li className="ul" style={{ fontWeight: "400px" }}><span style={{ fontWeight: "400px" }}>Review your order and complete the payment process.</span></li>
                    </ul>
                </ol>
                <ol start={4}>
                    <li style={{ fontWeight: "400px" }} className="ol"><b>Door Delivery:</b></li>
                    <ul  style={{marginTop:"10px",marginBottom:"10px"}}>
                        <li className="ul" style={{ fontWeight: "400px" }}><span style={{ fontWeight: "400px" }}>Your dress will be delivered to your doorstep, usually 1-2 days before your event.</span></li>
                        <li className="ul" style={{ fontWeight: "400px" }}><span style={{ fontWeight: "400px" }}>Unbox the dress and try it on to ensure it fits perfectly.</span></li>
                    </ul>
                </ol>
                <ol start={5}>
                    <li style={{ fontWeight: "400px" }} className="ol"><b>Reminder to Return Dress:</b></li>
                    <ul  style={{marginTop:"10px",marginBottom:"10px"}}>
                        <li className="ul" style={{ fontWeight: "400px" }}><span style={{ fontWeight: "400px" }}>RoyalHood will send you a reminder to return the dress as the end of your rental period approaches.</span></li>
                        <li className="ul" style={{ fontWeight: "400px" }}><span style={{ fontWeight: "400px" }}>This helps you stay on track and avoid any late fees.</span></li>
                    </ul>
                </ol>
                <ol start={6}>
                    <li style={{ fontWeight: "400px" }} className="ol"><b>Return It:</b></li>
                    <ul  style={{marginTop:"10px",marginBottom:"10px"}}>
                        <li className="ul" style={{ fontWeight: "400px" }}><span style={{ fontWeight: "400px" }}>Pack the dress in the original garment bag provided.</span></li>
                        <li className="ul" style={{ fontWeight: "400px" }}>
                            <span style={{ fontWeight: "400px" }}>Use the prepaid return shipping label and drop off the package at the designated shipping location.</span><span style={{ fontWeight: "400px" }}><br /></span>
                        </li>
                    </ul>
                    <li style={{ fontWeight: "400px" }} className="ol"><b>Check The Dress:</b></li>
                    <ul  style={{marginTop:"10px",marginBottom:"10px"}}>
                        <li className="ul" style={{ fontWeight: "400px" }}><span style={{ fontWeight: "400px" }}>Once the dress is returned, RoyalHood will inspect it for any damages or stains.</span></li>
                        <li className="ul" style={{ fontWeight: "400px" }}>
                            <span style={{ fontWeight: "400px" }}>If there are no issues, the process moves to the next step.</span><span style={{ fontWeight: "400px" }}><br /></span>
                        </li>
                    </ul>
                    <li style={{ fontWeight: "400px" }} className="ol"><b>Return Security Deposit:</b></li>
                    <ul  style={{marginTop:"10px",marginBottom:"10px"}}>
                        <li className="ul" style={{ fontWeight: "400px" }}><span style={{ fontWeight: "400px" }}>After the dress is checked and found to be in good condition, RoyalHood will return your security deposit.</span></li>
                        <li className="ul" style={{ fontWeight: "400px" }}><span style={{ fontWeight: "400px" }}>This completes the rental process.</span></li>
                    </ul>
                </ol>
                <p><span style={{ fontWeight: "400px" }}>By following these simple steps, you can enjoy wearing a beautiful dress from RoyalHood for your special occasion without the hassle of buying and storing a new outfit.</span></p>
            </div>
            <div class="tf-toolbar-bottom type-1150">
        <div class="toolbar-item">
            <a style={{color:"black"}} href="/">
                <div class="toolbar-icon">
                <IoHome />
                </div>
                <div class="toolbar-label">Home</div>
            </a>
        </div>
        <div class="toolbar-item">
            <a style={{color:"black"}} href="/products" >
                <div class="toolbar-icon">
                <BiCategoryAlt />
                </div>
                <div class="toolbar-label">Shop</div>
            </a>
        </div>
        <div class="toolbar-item">
            <a style={{color:"black"}} href="/SearchBar" >
                <div class="toolbar-icon">
                <IoSearchOutline />
                </div>
                <div class="toolbar-label">Search</div>
            </a>
        </div>
        <div class="toolbar-item">
            <a style={{color:"black"}} href="/cart">
                <div class="toolbar-icon">
                <FaShoppingCart />
                </div>
                <div class="toolbar-label">Cart</div>
            </a>
        </div>
    </div>
        </>
    );
};
export default RentalProcess;